import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Logo from '../Logo';
import { ReactComponent as BurgerIcon } from './menu.svg';

const Container = styled.header`
  ${tw`flex items-center justify-between px-6 bg-white px-4 border-b border-grey`}
  height: 56px;
`;

const BurgerButton = styled.button`
  ${tw`flex items-center justify-center`}
  margin-right: 20px;
  width: 24px;
  height: 24px;
  outline: none !important;
`;

export interface LayoutHeaderProps {
  logoHiddenOnMobile?: boolean;
  extraLeft?: React.ReactNode | React.FC<{ collapsed: boolean }>;
  extraRight?: React.ReactNode | React.FC<{ collapsed: boolean }>;
  toggleCollapsed: () => void;
  onClick?: () => void;
}

export default function Header({
  logoHiddenOnMobile,
  toggleCollapsed,
  extraLeft,
  extraRight,
  onClick,
}: LayoutHeaderProps) {
  return (
    <Container>
      <div className="flex items-center">
        <BurgerButton
          data-testid="toggle-sidebar-collapse-btn"
          onClick={toggleCollapsed}
        >
          <BurgerIcon />
        </BurgerButton>
        <Logo hasText onClick={onClick} hiddenOnMobile={logoHiddenOnMobile} />
        {extraLeft}
      </div>
      {extraRight && <div>{extraRight}</div>}
    </Container>
  );
}
